import { DBLink } from "@db-ux/react-core-components";
import React from "react";
import type { ComponentProps } from "react";
import clsx from "clsx";
import "./REDLink.css";

type REDLinkProps = ComponentProps<typeof DBLink> & {
    noDefaultUnderline?: boolean;
};

const REDLink: React.FC<REDLinkProps> = ({
    className,
    children,
    noDefaultUnderline = false,
    ...props
}) => {
    return (
        <DBLink
            className={clsx(
                noDefaultUnderline && "noUnderline hoverUnderline",
                className
            )}
            {...props}
        >
            {children}
        </DBLink>
    );
};

export default REDLink;